import * as React from "react";
import { SectionCommon } from "./layout/section-common";
import { Features } from "./features";
import { whiteLabelFeatures } from "../contents";
import { PricingLink } from "./pricing-link";
 
interface OurWhiteLabelProps {
  title: string | JSX.Element;
}

export const OurWhiteLabel = ({ title }: OurWhiteLabelProps) => (
  <SectionCommon
	// todo fix the line break on mobile.
    title={title}
    text="Agencies face many difficult decisions, but partnering with us shouldn't be one of them."
    headerStyles={{maxWidth: '595px'}}
  >
    <Features features={whiteLabelFeatures} />
    <PricingLink to="/pricing" className="btn-brand">
      SEE PLANS & PRICING
    </PricingLink>
  </SectionCommon>
);
